import * as types from './types';
import { searchApiService } from '../../services/searchApi';
import { SEARCH_REDUCERS } from './searchReducers';
import { isLoadingDataState } from '../../utils';

export const searchBarFields = (searchType, searchParams) => {
  return {
    type: types.PATIENT_SEARCH_FIELDS,
    payload: {
      searchType,
      searchParams,
    },
  };
};

export const setSearchForceRefresh = shouldForceRefresh => {
  return {
    type: types.SEARCH_FORCE_REFRESH,
    payload: shouldForceRefresh,
  };
};

export const clearSearchResults = () => {
  return {
    type: types.CLEAR_SEARCH_RESULTS,
  };
};

export const updateCurrentPage = page => {
  return {
    type: types.UPDATE_SEARCH_CURRENT_PAGE,
    payload: page,
  };
};

export const updateCurrentSort = sortData => {
  return {
    type: types.UPDATE_SEARCH_CURRENT_SORT,
    payload: sortData,
  };
};

export const getPatientSearchResults = (
  searchType,
  searchParams,
) => dispatch => {
  return dispatch({
    type: types.GET_PATIENT_RESULTS,
    payload: searchApiService(searchType, searchParams),
  }).catch(err => console.log(err));
};

export const getScrollableSearchResults = (
  searchType,
  searchParams,
  actionType = types.GET_INFINITE_SCROLL_PATIENT_RESULT,
) => dispatch => {
  return dispatch({
    type: actionType,
    payload: searchApiService(searchType, searchParams),
  });
};

const isPageFetched = (search, page) => {
  return (
    search[SEARCH_REDUCERS.INFINITE_SCROLL_REDUCER].pages[page] !== undefined
  );
};

export const pagedScrollableSearchResults = (
  searchType,
  searchParams,
  page,
) => (dispatch, getState) => {
  const { search } = getState();
  if (isPageFetched(search, page)) {
    return Promise.resolve(
      search[SEARCH_REDUCERS.INFINITE_SCROLL_REDUCER].pages[page],
    );
  }

  return dispatch(
    getScrollableSearchResults(
      searchType,
      {
        ...searchParams,
        page,
      },
      types.PAGE_INFINITE_SCROLL_PATIENT_RESULT,
    ),
  ).then(() => {
    return {
      ...isLoadingDataState(),
      page,
    };
  });
};



// WEBPACK FOOTER //
// ./src/state/reducers/search/searchActions.js